import { trpc } from '@/shared/api/trpc';

// Place search for the Location & Time picker. Proxied through `geocode.search`
// (Google Places) so the API key stays server-side and named venues resolve —
// OpenStreetMap/Nominatim (the previous provider) doesn't index most POIs.
export const useLocationGeocode = (query: string) => {
  const trimmed = query.trim();
  return trpc.geocode.search.useQuery(
    { query: trimmed },
    { enabled: trimmed.length >= 3, staleTime: 1000 * 60 * 5 }
  );
};
